export const AnalyticsEvents = {
    // Authentication Events
    USER_SIGNED_UP: 'user_signed_up',
    USER_LOGGED_IN: 'user_logged_in',

    // Creation Events
    LOCATION_ENTRY_VIEWED: 'location_entry_viewed',
    JOBSITE_CREATED: 'jobsite_created',
    PUNCH_ITEM_CREATED: 'punch_item_created',
    JOBSITE_STATUS_SELECTED: 'jobsite_status_selected',
    OCCUPANT_CONTACT_ADDED: 'occupant_contact_added',
    JOBSITE_CONTACT_ADDED: 'jobsite_contact_added',
    IMPORTANT_DATE_SAVED: 'important_date_saved',
    IMPORTANT_NOTE_SAVED: 'important_note_saved',
    TRADE_CONTACT_ADDED: 'trade_contact_added',
    TRADE_CONTACTS_SUMMARY_VIEWED: 'trade_contacts_summary_viewed',
    TRADE_CONTACT_REMOVED: 'trade_contact_removed',
    TRADE_PRIMARY_CONTACT_CHANGED: 'trade_primary_contact_changed',
    TRADE_DUE_DATE_SAVED: 'trade_due_date_saved',
    PUNCH_SENT: 'punch_sent',

    STATUS_CHANGED: 'status_changed',
    ITEM_VIEWED: 'item_viewed',
    ITEM_REASSIGNED: 'item_reassigned',
    PHOTO_UPLOADED_PRE_SEND: 'photo_uploaded_pre_send',
    PHOTO_UPLOADED_POST_SEND: 'photo_uploaded_post_send',
    PHOTO_DELETED: 'photo_deleted',
    PHOTO_MARKUP_ADDED: 'photo_markup_added',
    COMMENT_ADDED: 'comment_added',
    CHAT_VIEWED: 'chat_viewed',
    CHAT_MESSAGE_SENT: 'chat_message_sent',

    CONTACTS_PREPERMISSION_VIEWED: 'contacts_prepermission_viewed',
    CONTACTS_PREPERMISSION_CONTINUE_CLICKED: 'contacts_prepermission_continue_clicked',
    CONTACTS_PREPERMISSION_MANUAL_CLICKED: 'contacts_prepermission_manual_clicked',
    CONTACTS_PERMISSION_RESULT: 'contacts_permission_result',

} as const;

export type AnalyticsEventName = (typeof AnalyticsEvents)[keyof typeof AnalyticsEvents];
